module.exports = __webpack_public_path__ + "img/m_top_partner.15bf1137.jpg";